export const COLORS = {
  bg: '#0B0D0E',
  surface: '#111315',
  surfaceHover: '#1A1C1E',
  accent: '#8b3eff', 
  accentMuted: 'rgba(139, 62, 255, 0.2)',
  textPrimary: '#EDEDED',
  textSecondary: '#9AA0A6',
  border: '#262626',
};

export const DEFAULT_KEYWORDS = [
  'Artificial Intelligence',
  'Generative AI',
  'Machine Learning',
  'Computer Vision',
  'Robotics',
  'AI Infrastructure',
  'AI in Healthcare',
  'AI in Finance',
  'AI Systems / MLOps'
];

export const SHEET_SCHEMA_ORDER = [
  'Campaign Name',
  'Category',
  'URL',
  'priority',
  'year',
  'month',
  'start_date',
  'end_date',
  'location',
  'focus_area',
  'information',
  'added_at'
];

export const CATEGORIES = [
  'General AI',
  'AI in Healthcare',
  'AI Infrastructure / Systems',
  'AI in Finance',
  'AI in Robotics',
  'AI in Education',
  'AI Policy & Ethics',
  'Consumer AI'
];

export const PRIORITY_LEVELS = [
  'High',
  'Medium',
  'Low',
  'Monitor Only'
];